export default __webpack_public_path__ + "static/media/GMP.4ffcc2ff.png";